import React, {CSSProperties, ReactNode} from 'react';
import cx from 'classnames';
import styles from './styles.module.scss';

cx.bind(styles);

type Props = {
    columnCount?: 0 | 1 | 2 | 3;
    children?: ReactNode;
    componentClasses?: string;
    style?: CSSProperties;
};

export const GridContainer = ({children, componentClasses, columnCount = 1, style = {}}: Props) => {
    return (
        <div
            className={cx(styles.component, componentClasses, {
                [styles[`columnCount${columnCount}`]]: columnCount
            })}
            style={style}
        >
            {children}
        </div>
    );
};
